import React from 'react'
import { PageValidationError } from '../../../../../../../../domain/entity/version-report/VersionReportTemplateEntity/validator'
import { ProgressOverviewConfigForm } from './components/ProgressOverviewConfigForm'
import { ProgressReportByProcessConfigForm } from './components/ProgressReportByProcessConfigForm'
import { ProgressReportByTeamConfigForm } from './components/ProgressReportByTeamConfigForm'
import { EmptyConfigContainer, EmptyConfigText } from './styles'
import { VersionReportTemplatePageFormModel } from '../../model/VersionReportTemplatePageFormModel'

const PAGE_CONFIG_COMPONENTS = {
  PROGRESS_OVERVIEW: ProgressOverviewConfigForm,
  PROGRESS_REPORT_BY_PROCESS: ProgressReportByProcessConfigForm,
  PROGRESS_REPORT_BY_TEAM: ProgressReportByTeamConfigForm,
} as const

type ConfigFormProps = {
  page: VersionReportTemplatePageFormModel
  projectUuid: string
  validationErrors?: PageValidationError[]
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportTemplatePageFormModel
    ) => VersionReportTemplatePageFormModel
  ) => void
}

export const PageConfigForm: React.FC<ConfigFormProps> = ({
  page,
  projectUuid,
  validationErrors,
  onUpdate,
}) => {
  const ConfigComponent = PAGE_CONFIG_COMPONENTS[page.pageType]

  if (!ConfigComponent) {
    return (
      <EmptyConfigContainer>
        <EmptyConfigText>
          選択されたページタイプの設定フォームはまだ実装されていません
        </EmptyConfigText>
      </EmptyConfigContainer>
    )
  }

  return (
    <ConfigComponent
      page={page}
      projectUuid={projectUuid}
      validationErrors={validationErrors}
      onUpdate={onUpdate}
    />
  )
}
